import { render, staticRenderFns } from "./ViewEncounters.vue?vue&type=template&id=b421d226&"
import script from "./ViewEncounters.vue?vue&type=script&lang=js&"
export * from "./ViewEncounters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports